import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Patients from './pages/Patients';
import ECPLogin from './pages/ECPLogin';
import PatientsDetails from './pages/PatientDetails';
import StandardCare from './pages/StandardCare';
import NotFound from './pages/NotFound';
import ProtectedRoute from './auth/ProtectedRoute';

import { LoginCallback } from '@okta/okta-react';

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/login" element={<ECPLogin />} />
            <Route path='login/callback' element={<LoginCallback loadingElement={<h3 id='loading-icon'>Loading...</h3>} />} />
            <Route
                path="/"
                element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/patients"
                element={
                    <ProtectedRoute>
                        <Patients />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/patients/:userid/:patientId"
                element={
                    <ProtectedRoute>
                        <PatientsDetails />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/patients/standardcare/:userid/:patientId"
                element={
                    <ProtectedRoute>
                        <StandardCare />
                    </ProtectedRoute>
                }
            />
            {/* Catch-all route for 404 Not Found */}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default AppRoutes;